var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeuronIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1439,
    height: 1296,
    viewBox: "0 0 1439 1296",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.570007 539.22C0.570007 466.49 14.85 395.86 43 329.29C70.17 265.06 109.03 207.41 158.5 157.94C207.97 108.46 265.63 69.6 329.85 42.44C396.42 14.28 467.05 0 539.78 0C612.51 0 683.14 14.28 749.71 42.43C813.94 69.6 871.59 108.46 921.06 157.93C970.53 207.4 1009.39 265.06 1036.56 329.28C1064.72 395.85 1078.99 466.48 1078.99 539.21V1078.99H919.1C832.5 1078.99 761.99 1010.14 759.3 924.2H759.21V539.21H759.78C759.78 417.9 661.09 319.21 539.78 319.21C418.47 319.21 319.78 417.9 319.78 539.21V924.2H319.69C316.99 1010.14 246.48 1078.99 159.89 1078.99C73.3 1078.99 2.78003 1010.14 0.0900269 924.2H0V539.21H0.570007V539.22Z",
    fill: "url(#paint0_linear_7_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079 1296H1296V1079H1079V1296Z",
    fill: "#3360F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1297 1079H1439V937H1297V1079Z",
    fill: "#3072FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.02 98C811.76 98 915.22 150.58 983.82 233.15C1004.57 263.2 1022.2 295.32 1036.57 329.29C1064.73 395.86 1079 466.49 1079 539.22V1079H919.11C832.51 1079 762 1010.15 759.31 924.21H759.22V539.22H759.79C759.79 417.91 661.1 319.22 539.79 319.22C431.5 319.22 341.24 397.87 323.12 501.04C322.38 491.46 322.01 481.78 322.01 472.02C322.01 265.46 489.46 98 696.03 98H696.02Z",
    fill: "#3360F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7_2",
    x1: 737.91,
    y1: 33.93,
    x2: 436.5,
    y2: 1158.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77BAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E71F7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1439,
    height: 1296,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeuronIcon);
export default __webpack_public_path__ + "static/media/neuron_icon.3f2c323b038e66a45dbfdd0a950a804f.svg";
export { ForwardRef as ReactComponent };